var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAwsRds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 43.1302L9.61857 49.7148L10.1238 49.1147V6.99873L9.61857 6.3623L4 12.9444V43.1302Z",
    fill: "#1A476F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.61938 49.7148L20.3552 55.0823L20.8018 54.3638L20.8091 1.56238L20.3627 1L9.61938 6.35031V49.7148Z",
    fill: "#1F5B98"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.99 12.9444L46.3699 6.3623L45.7413 6.56139L45.8662 49.1773L46.3699 49.7148L51.99 43.131V12.9444Z",
    fill: "#2D72B8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.634 55.0823L46.3699 49.7148V6.35031L35.6265 1L35.1185 1.68742L35.1258 54.3012L35.634 55.0823Z",
    fill: "#5294CF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3627 1H35.6265V55.0831H20.3627V1Z",
    fill: "#2D72B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAwsRds);
export default __webpack_public_path__ + "static/media/icon-aws-rds.188e731c0b32c52c68db843e23f09032.svg";
export { ForwardRef as ReactComponent };